__turbopack_context__.v({
  "container": "_0BmFXq_container",
  "filterChip": "_0BmFXq_filterChip",
  "filtersList": "_0BmFXq_filtersList",
  "filtersSection": "_0BmFXq_filtersSection",
  "headingSection": "_0BmFXq_headingSection",
  "preferenceChip": "_0BmFXq_preferenceChip",
});
